import React from "react";
import {Divider} from '@material-ui/core';
import styles from './Conclusion.module.scss';
import DetailRow from "./components/priceRow";
import percentage from 'calculate-percentages'

export interface IConclusionProps {
  currency?: number;
  originalPrice?: number;
  salePrice?: number;

  hideDiscount?: boolean;

  children?: any;

  originalPriceComponent?: any;
  savingsPriceComponent?: any;

  savingsPriceLabel?: string;

}

const Conclusion = (props: IConclusionProps) => (
  <div className={`${styles.priceConclusionContainer}`}>
    {props.children ? props.children : <>
      {props.originalPriceComponent ? props.originalPriceComponent :
        <>
          <DetailRow
            label=" המחיר בו נרכשו השוברים / כרטיסים"
            price={props.originalPrice}
            currency={props.currency}
            labelClassName={styles.originalLabel}
            priceClassName={styles.originalPrice}
            hideWhenNoPrice
          />
          <Divider/>
        </>
      }
      <DetailRow
        label="מחיר המכירה"
        price={props.salePrice}
        currency={props.currency}
        labelClassName={styles.saleLabel}
        priceClassName={styles.salePrice}

        hideWhenNoPrice
      />
      <Divider/>
      {props.savingsPriceComponent ? props.savingsPriceComponent : <>
        <span className={styles.savings}>
          {['החיסכון שלך', `${100 - Math.floor(percentage.calculate(props.salePrice, props.originalPrice))}%`].join(" ")}
        </span>
      </>}
    </>}

  </div>
);

Conclusion.defaultProps = {
  savingsPriceLabel: 'החיסכון שלך',
  hideDiscount: false,
};

export default React.memo(Conclusion);
